export const actScienceWorksheets = [
  // ─── INTERPRETATION OF DATA ────────────────────────────────────────────────
  {
    id: 'act-sci-reading-tables',
    title: 'ACT Science: Reading Tables & Extracting Data',
    description: 'Practice reading scientific tables, identifying trends, extracting specific values, and comparing data points across rows and columns.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Interpretation of Data',
    difficulty: 'Advanced' as const,
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/act-sci-reading-tables.pdf',
    thumbnailUrl: 'https://public.readdy.ai/ai/img_res/f4619993b4e5cbd896179e30ffd2cd4a.jpg'
  },
  {
    id: 'act-sci-reading-graphs',
    title: 'ACT Science: Reading Graphs & Charts',
    description: 'Interpret line graphs, bar charts, scatter plots, and pie charts; identify maximum/minimum values, trends, and relationships between variables.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Interpretation of Data',
    difficulty: 'Advanced' as const,
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/act-sci-reading-graphs.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20graphs%20charts%20line%20graphs%20bar%20charts%20scatter%20plots%20pie%20charts%20data%20interpretation%20trends%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci002&orientation=portrait'
  },
  {
    id: 'act-sci-identifying-trends',
    title: 'ACT Science: Identifying Trends & Patterns',
    description: 'Recognize increasing/decreasing trends, direct/inverse relationships, periodic patterns, and correlations in scientific data.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Interpretation of Data',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-sci-identifying-trends.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20identifying%20trends%20patterns%20increasing%20decreasing%20direct%20inverse%20relationships%20correlations%20scientific%20data%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci003&orientation=portrait'
  },
  {
    id: 'act-sci-interpolation-extrapolation',
    title: 'ACT Science: Interpolation & Extrapolation',
    description: 'Estimate values between data points (interpolation) and predict values beyond the data range (extrapolation) using graphs and tables.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Interpretation of Data',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-sci-interpolation-extrapolation.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20interpolation%20extrapolation%20estimate%20predict%20values%20between%20beyond%20data%20points%20graphs%20tables%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci004&orientation=portrait'
  },
  {
    id: 'act-sci-translating-data',
    title: 'ACT Science: Translating Between Data Formats',
    description: 'Convert information between tables, graphs, diagrams, and written descriptions; match data representations to scenarios.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Interpretation of Data',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-sci-translating-data.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20translating%20data%20formats%20convert%20tables%20graphs%20diagrams%20written%20descriptions%20match%20representations%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci005&orientation=portrait'
  },
  {
    id: 'act-sci-calculating-rates',
    title: 'ACT Science: Calculating Rates of Change',
    description: 'Calculate slopes, rates of change, and average values from graphs and tables; determine which variable changes faster.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Interpretation of Data',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-sci-calculating-rates.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20calculating%20rates%20of%20change%20slopes%20average%20values%20graphs%20tables%20speed%20velocity%20acceleration%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci006&orientation=portrait'
  },
  {
    id: 'act-sci-comparing-data-sets',
    title: 'ACT Science: Comparing Data Sets',
    description: 'Compare multiple experiments, trials, or conditions; identify similarities, differences, and which data set shows the strongest effect.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Interpretation of Data',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-sci-comparing-data-sets.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20comparing%20data%20sets%20multiple%20experiments%20trials%20conditions%20similarities%20differences%20strongest%20effect%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci007&orientation=portrait'
  },

  // ─── SCIENTIFIC INVESTIGATION ──────────────────────────────────────────────
  {
    id: 'act-sci-experimental-design',
    title: 'ACT Science: Experimental Design Principles',
    description: 'Identify control groups, experimental groups, sample size, randomization, and proper experimental setup in scientific studies.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Scientific Investigation',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-sci-experimental-design.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20experimental%20design%20control%20group%20experimental%20group%20sample%20size%20randomization%20setup%20scientific%20method%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci008&orientation=portrait'
  },
  {
    id: 'act-sci-identifying-variables',
    title: 'ACT Science: Identifying Variables',
    description: 'Distinguish between independent variables (manipulated), dependent variables (measured), and controlled variables (constants).',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Scientific Investigation',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-sci-identifying-variables.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20identifying%20variables%20independent%20dependent%20controlled%20constants%20manipulated%20measured%20scientific%20experiments%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci009&orientation=portrait'
  },
  {
    id: 'act-sci-understanding-procedures',
    title: 'ACT Science: Understanding Experimental Procedures',
    description: 'Interpret step-by-step procedures, identify the purpose of each step, and recognize proper experimental techniques.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Scientific Investigation',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-sci-understanding-procedures.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20experimental%20procedures%20step%20by%20step%20purpose%20techniques%20laboratory%20methods%20scientific%20process%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci010&orientation=portrait'
  },
  {
    id: 'act-sci-selecting-tools',
    title: 'ACT Science: Selecting Tools & Measurements',
    description: 'Choose appropriate measuring instruments, determine precision requirements, and identify correct units for scientific measurements.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Scientific Investigation',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-sci-selecting-tools.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20selecting%20tools%20measurements%20instruments%20precision%20units%20scientific%20equipment%20laboratory%20tools%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci011&orientation=portrait'
  },
  {
    id: 'act-sci-evaluating-validity',
    title: 'ACT Science: Evaluating Experimental Validity',
    description: 'Assess whether experiments are well-designed, identify sources of error, and determine if conclusions are supported by data.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Scientific Investigation',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-sci-evaluating-validity.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20evaluating%20validity%20experimental%20design%20sources%20of%20error%20conclusions%20supported%20by%20data%20scientific%20reasoning%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci012&orientation=portrait'
  },

  // ─── EVALUATION OF MODELS ──────────────────────────────────────────────────
  {
    id: 'act-sci-comparing-viewpoints',
    title: 'ACT Science: Comparing Conflicting Viewpoints',
    description: 'Analyze competing scientific theories, identify key differences, and determine what evidence would support or refute each viewpoint.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Evaluation of Models',
    difficulty: 'Advanced' as const,
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/act-sci-comparing-viewpoints.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20comparing%20conflicting%20viewpoints%20competing%20theories%20key%20differences%20evidence%20support%20refute%20scientific%20arguments%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci013&orientation=portrait'
  },
  {
    id: 'act-sci-evaluating-hypotheses',
    title: 'ACT Science: Evaluating Hypotheses with New Evidence',
    description: 'Determine which hypothesis is better supported when new experimental data is presented; assess consistency with predictions.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Evaluation of Models',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-sci-evaluating-hypotheses.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20evaluating%20hypotheses%20new%20evidence%20experimental%20data%20predictions%20consistency%20scientific%20reasoning%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci014&orientation=portrait'
  },
  {
    id: 'act-sci-drawing-conclusions',
    title: 'ACT Science: Drawing Conclusions from Data',
    description: 'Make valid inferences based on experimental results, avoid overgeneralization, and distinguish between correlation and causation.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Evaluation of Models',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-sci-drawing-conclusions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20drawing%20conclusions%20inferences%20experimental%20results%20correlation%20causation%20overgeneralization%20scientific%20reasoning%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci015&orientation=portrait'
  },
  {
    id: 'act-sci-identifying-assumptions',
    title: 'ACT Science: Identifying Assumptions',
    description: 'Recognize unstated assumptions underlying scientific arguments, experiments, and conclusions; assess whether assumptions are reasonable.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Evaluation of Models',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-sci-identifying-assumptions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20identifying%20assumptions%20unstated%20underlying%20scientific%20arguments%20experiments%20conclusions%20reasonable%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci016&orientation=portrait'
  },
  {
    id: 'act-sci-determining-support',
    title: 'ACT Science: Determining Which Theory is Better Supported',
    description: 'Evaluate multiple theories or models against evidence, identify which is most consistent with data, and explain why.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Evaluation of Models',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-sci-determining-support.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20determining%20theory%20support%20evaluate%20models%20evidence%20consistency%20data%20scientific%20reasoning%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci017&orientation=portrait'
  },

  // ─── CONTENT AREA FOCUSED DRILLS ───────────────────────────────────────────
  {
    id: 'act-sci-biology-passages',
    title: 'ACT Science: Biology-Focused Passages',
    description: 'Practice with biology-themed passages covering cell biology, genetics, ecology, evolution, and natural selection.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Biology Content',
    difficulty: 'Advanced' as const,
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/act-sci-biology-passages.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20biology%20passages%20cell%20biology%20genetics%20ecology%20evolution%20natural%20selection%20DNA%20RNA%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci018&orientation=portrait'
  },
  {
    id: 'act-sci-chemistry-passages',
    title: 'ACT Science: Chemistry-Focused Passages',
    description: 'Practice with chemistry-themed passages covering pH, phase changes, solubility, reactions, and molecular structure.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Chemistry Content',
    difficulty: 'Advanced' as const,
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/act-sci-chemistry-passages.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20chemistry%20passages%20pH%20phase%20changes%20solubility%20reactions%20molecular%20structure%20acids%20bases%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci019&orientation=portrait'
  },
  {
    id: 'act-sci-physics-passages',
    title: 'ACT Science: Physics-Focused Passages',
    description: 'Practice with physics-themed passages covering forces, motion, energy, momentum, gravity, and density.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Physics Content',
    difficulty: 'Advanced' as const,
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/act-sci-physics-passages.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20physics%20passages%20forces%20motion%20energy%20momentum%20gravity%20density%20acceleration%20velocity%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci020&orientation=portrait'
  },
  {
    id: 'act-sci-earth-space-passages',
    title: 'ACT Science: Earth & Space Science Passages',
    description: 'Practice with Earth/Space science passages covering geology, astronomy, meteorology, oceanography, and climate.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Earth/Space Content',
    difficulty: 'Advanced' as const,
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/act-sci-earth-space-passages.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20earth%20space%20science%20passages%20geology%20astronomy%20meteorology%20oceanography%20climate%20weather%20rocks%20planets%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci021&orientation=portrait'
  },

  // ─── PASSAGE FORMAT DRILLS ─────────────────────────────────────────────────
  {
    id: 'act-sci-data-representation',
    title: 'ACT Science: Data Representation Passages',
    description: 'Focused practice on Data Representation passages (2-3 per test) — pure data analysis with graphs, tables, and diagrams.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Data Representation',
    difficulty: 'Advanced' as const,
    pages: 9,
    isFree: false,
    downloadUrl: '/downloads/act-sci-data-representation.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20data%20representation%20passages%20graphs%20tables%20diagrams%20pure%20data%20analysis%20trends%20patterns%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci022&orientation=portrait'
  },
  {
    id: 'act-sci-research-summaries',
    title: 'ACT Science: Research Summaries Passages',
    description: 'Focused practice on Research Summaries passages (2-3 per test) — experimental design, procedures, and results analysis.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Research Summaries',
    difficulty: 'Advanced' as const,
    pages: 9,
    isFree: false,
    downloadUrl: '/downloads/act-sci-research-summaries.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20research%20summaries%20passages%20experimental%20design%20procedures%20results%20analysis%20scientific%20method%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci023&orientation=portrait'
  },
  {
    id: 'act-sci-conflicting-viewpoints',
    title: 'ACT Science: Conflicting Viewpoints Passages',
    description: 'Focused practice on Conflicting Viewpoints passages (1 per test) — comparing competing theories and scientific arguments.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Conflicting Viewpoints',
    difficulty: 'Advanced' as const,
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/act-sci-conflicting-viewpoints.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20worksheet%20conflicting%20viewpoints%20passages%20competing%20theories%20scientific%20arguments%20compare%20contrast%20evidence%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci024&orientation=portrait'
  },

  // ─── FULL DOMAIN REVIEW PACKS ──────────────────────────────────────────────
  {
    id: 'act-sci-review-interpretation',
    title: 'ACT Science: Interpretation of Data Full Review',
    description: 'Comprehensive review of all Interpretation of Data skills: reading tables/graphs, trends, interpolation, translating formats, rates, and comparisons.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Interpretation of Data',
    difficulty: 'Advanced' as const,
    pages: 16,
    isFree: false,
    downloadUrl: '/downloads/act-sci-review-interpretation.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20interpretation%20of%20data%20full%20review%20comprehensive%20tables%20graphs%20trends%20interpolation%20rates%20comparisons%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci025&orientation=portrait'
  },
  {
    id: 'act-sci-review-investigation',
    title: 'ACT Science: Scientific Investigation Full Review',
    description: 'Complete review of Scientific Investigation skills: experimental design, variables, procedures, tools, and validity assessment.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Scientific Investigation',
    difficulty: 'Advanced' as const,
    pages: 14,
    isFree: false,
    downloadUrl: '/downloads/act-sci-review-investigation.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20scientific%20investigation%20full%20review%20experimental%20design%20variables%20procedures%20tools%20validity%20assessment%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci026&orientation=portrait'
  },
  {
    id: 'act-sci-review-evaluation',
    title: 'ACT Science: Evaluation of Models Full Review',
    description: 'Full review of Evaluation of Models skills: comparing viewpoints, evaluating hypotheses, drawing conclusions, assumptions, and theory support.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Evaluation of Models',
    difficulty: 'Advanced' as const,
    pages: 15,
    isFree: false,
    downloadUrl: '/downloads/act-sci-review-evaluation.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20evaluation%20of%20models%20full%20review%20comparing%20viewpoints%20hypotheses%20conclusions%20assumptions%20theory%20support%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci027&orientation=portrait'
  },

  // ─── TIMED PRACTICE SETS ───────────────────────────────────────────────────
  {
    id: 'act-sci-timed-set-1',
    title: 'ACT Science: Timed Practice Set 1',
    description: 'Full-length timed practice set with 6-7 passages (40 questions) — simulate real test conditions with mixed passage types.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Full Practice',
    difficulty: 'Advanced' as const,
    pages: 18,
    isFree: false,
    downloadUrl: '/downloads/act-sci-timed-set-1.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20timed%20practice%20set%20full%20length%2040%20questions%20mixed%20passages%20simulate%20test%20conditions%20timer%20clock%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci028&orientation=portrait'
  },
  {
    id: 'act-sci-timed-set-2',
    title: 'ACT Science: Timed Practice Set 2',
    description: 'Full-length timed practice set with 6-7 passages (40 questions) — different passages from Set 1 for additional practice.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Full Practice',
    difficulty: 'Advanced' as const,
    pages: 18,
    isFree: false,
    downloadUrl: '/downloads/act-sci-timed-set-2.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20timed%20practice%20set%20two%20full%20length%2040%20questions%20mixed%20passages%20different%20scenarios%20timer%20clock%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actsci029&orientation=portrait'
  },
  {
    id: 'act-sci-timed-set-3',
    title: 'ACT Science: Timed Practice Set 3',
    description: 'Full-length timed practice set with 6-7 passages (40 questions) — advanced difficulty for final test prep.',
    grade: 'ACT Science',
    subject: 'Test Prep',
    topic: 'Full Practice',
    difficulty: 'Advanced' as const,
    pages: 18,
    isFree: false,
    downloadUrl: '/downloads/act-sci-timed-set-3.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20science%20timed%20practice%20set%20three%20full%20length%2040%20questions%20advanced%20difficulty%20final%20prep%20timer%20clock%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actsci030&orientation=portrait'
  },
];